import { render, staticRenderFns } from "./HeartshapedTinplateBadge.vue?vue&type=template&id=5b5c4a5c&scoped=true&"
import script from "./HeartshapedTinplateBadge.vue?vue&type=script&lang=js&"
export * from "./HeartshapedTinplateBadge.vue?vue&type=script&lang=js&"
import style0 from "./HeartshapedTinplateBadge.vue?vue&type=style&index=0&id=5b5c4a5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5c4a5c",
  null
  
)

component.options.__file = "HeartshapedTinplateBadge.vue"
export default component.exports